import axios from 'axios';

export async function EvoxMediaDriveIn(styleId, typeOfAnimation, params = '') {
  if (typeOfAnimation && styleId) {
    let animationType = 'DriveIn';
    if (typeOfAnimation.toLowerCase() === '360-spin') {
      animationType = 'Spin';
    }
    let evoxUrlPath = `${window.ApiBaseUrl}/EnhancedMediaAssetSettings/GetEvoxVidResponse?DealerID=${window.accountId}&StyleId=${styleId}&VideoType=${animationType}`;
    if (params) {
      evoxUrlPath = `${evoxUrlPath}${params}`;
    }
    let response = await axios.get(evoxUrlPath);
    if (response) {
      if (response.headers && response.headers['content-type'] === 'video/mp4') {
        return {
          assetUrl: evoxUrlPath,
          assetType: 'video',
        };
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export function showEvoxVideoForBestSites() {
  let campaignIds = ['521', '3617', '3727', '3724', '5281', '3725'];
  return campaignIds.some((campaignId) => campaignId === window.campaignId);
}
